<template>
    <div class="contact-person row no-gutters" :class="{'w-100 h-100': loading, 'ml-4': !loading}">
        <div class="w-100 h-100 mt-5 pt-5" v-if="loading">
            <Loading/>
        </div>
        <template v-if="!loading && person">
            <div class="contact-data col-6">
                <p v-if="person.globalContact === false">Teší ma, že ako Váš osobný investičný manažér Vám môžem byť kedykoľvek nápomocný.</p>
                <p v-if="person.globalContact === true">Teší nás, že Vám môžeme byť v oblasti investícií kedykoľvek nápomocní.</p>
                <strong class="name">{{person.fullName}}</strong>
                <a :href="'mailto:' + person.email">{{person.email}}</a>
                <a :href="'tel:'+ cleanPhone">{{person.phone}}</a>
                <a :href="'mailto:'+ person.email" class="btn btn-primary mt-3 btn-sm">Kontaktovať</a>
            </div>
            <div class="col-6 contact-photo-wrapper" :class="{'global-image': person.globalContact}">
                <img :src="person.globalContact ? person.image : getImage(person.image)" class="img-fluid" :alt="person.fullName">
            </div>
        </template>
    </div>
</template>

<script>
    import {publicPath} from "../main";
    import Loading from "./Loading";
    import {getImageFromBytea} from "@/store/helpers";

    export default {
        name: "ContactPerson",
        components: {Loading},
        mounted() {
            this.$store.dispatch('content/salesPerson')
        },
        computed: {
            loading() {
                return this.$store.state.content.loadingContact;
            },
            person() {
                return this.$store.state.content.salesPerson;
            },
            cleanPhone() {
                return this.person === null ? '' : this.person.phone.replace(/\s+/g, '');
            }
        },
        methods: {
            getImage(input) {
                return getImageFromBytea(input);
            }
        },
        data() {
            return {
                publicPath: publicPath
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/styles/variables.scss";

    .contact-person {
        p {
            font-size: 13px;
            margin-bottom: 10px;
        }

        .name {
            display: block;
            margin-bottom: 5px;
        }

        a:not(.btn) {
            color: $secondary-text;
            font-size: 13px;
            display: block;
        }

        .contact-data {
            padding-bottom: 30px;
            margin-top: 10px;
        }

        .contact-photo-wrapper {
            display: flex;
            align-items: flex-end;
            justify-content: center;

            &.global-image {
                align-items: center;
                margin-top: -50px;

                .img-fluid {
                    max-width: 80px;
                }
            }

        }
    }
</style>